import React from "react";
import logo from "../../../images/branding/rlink-white-logo.png";
import background from "../../../images/branding/meeting-background.png";

const ConfLeftPanel = () => (
  <div
    className="flex flex-col lg:w-[80%] w-full h-[400px] sm:h-[250px] md:h-[300px] lg:h-auto lg:min-h-screen justify-between bg-cover bg-center bg-no-repeat lg:bg-cover lg:bg-center lg:bg-no-repeat"
    style={{
      backgroundImage: `url(${background})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}
  >
    <div className="relative ml-0 sm:ml-[10%] sm:mt-[5%] md:mt-[0%] lg:mt-[10%] md:ml-[8%] lg:ml-[10%] flex flex-col h-full lg:h-[80%] px-4 sm:px-0">
      <div className="mt-4 sm:mt-[5%] md:mt-[15%] mb-2 sm:mb-4 md:mb-6 lg:mb-8 flex justify-center lg:justify-start">
        <img
          className="w-auto h-auto max-w-[100px] sm:max-w-[120px] md:max-w-[140px] lg:max-w-[180px] mr-2"
          src={logo}
          alt="logo"
        />
      </div>
      <div className="absolute bottom-4 sm:bottom-[15vh] left-4 sm:left-0 md:block text-white text-4xl  md:text-4xl lg:text-7xl font-bold mb-2 sm:mb-4 md:mb-6 leading-tight opacity-20">
        Meet.
        <br /> Earn.
        <br /> Repeat.
      </div>
    </div>
  </div>
);

export default ConfLeftPanel;
